import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";

const Advisors = ({ match }) => {
  return (
    <div className="app-wrapper">
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/listing`} />
        <Route
          path={`${match.url}/listing`}
          component={asyncComponent(() => import("./routes/Listing"))}
        />
        <Route
          path={`${match.url}/:advisorId/accounts`}
          component={asyncComponent(() => import("./routes/Accounts"))}
        />
        <Route
          component={asyncComponent(() =>
            import("app/routes/extraPages/routes/404")
          )}
        />
      </Switch>
    </div>
  );
};

export default Advisors;
